import templateUrl from './txSelect.html';
import styling from './txSelect.less';

export default angular
    .module('eventix.common.directives.txSelect', ['ui.bootstrap.dropdown'])
    .factory('txOptionParser', function($parse) {
        //                          1111111111-----------2222222222---------------------3333333333-----------4444444444---------------------------5555555555-----------------------66666666-------------777777777777777777-----------88888888
        var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?)?(?:\s+disable\s+when\s+([\s\S]+?))?(?:\s+with\s+icon\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
        return {
            parse: function(input) {
                var match = input.match(TYPEAHEAD_REGEXP);
                if (!match) {
                    throw new Error(
                        'Expected option specification in form of "_modelValue_( as _label_)?( group by _group_( as _groupLabel_)?)?( disable when _disable_)?(with icon _icon_)? for _item_ in _collection_"' +
                        ' but got "' +
                        input +
                        '".'
                    );
                }

                return {
                    itemName: match[7],
                    source: $parse(match[8]),
                    groupBy: match[3] ? $parse(match[3]) : null,
                    groupLabel: match[4] ? $parse(match[4]) : null,
                    disableWhen: match[5] ? $parse(match[5]) : null,
                    withIcon: match[6] ? $parse(match[6]) : null,
                    viewMapper: $parse(match[2] || match[1]),
                    modelMapper: $parse(match[1])
                };
            }
        };
    })
    /**
     * @ngdoc directive
     * @name eventix.common.directives:txSelect
     * @restrict element
     * @description
     * A select dropdown with advanced options
     *
     * @param {Expression} txOptions An Angular expression that specifies the selectable options
     * Format: `_modelValue_( as _label_)?( group by _group_( as _groupLabel_)?)?( disable when _disable_)?` `for _item_ in _collection_`
     * @param {Expression} ngModel Where the selection should be saved
     * @param {Expression} beforeSelect A callback run before an item is selected. It'll wait when a promise is
     * returned, and cancel when it rejects. `before-select="checkSometing(item)"`
     * @param {Expression} beforeDeselect A callback run before an item is deselected. It'll wait when a promise is
     * returned, and cancel when it rejects. `before-deselect="checkSometing(item)"`
     * @param {String} [btnClass='btn btn-default'] CSS class for the dropdown toggle button
     * @param {Expression} dropdownClass Value for class attribute to be given to the dropdown menu element
     * @param {Expression} [sublabel=null] By default, a selectable item has one label. Adding this attribute
     * ads a subtitle to the label.
     * @param {Boolean} [filter=false] Enable a search input (auto-enabled if more than 11 items)
     * @param {Boolean} [multiple=false] Allow a selection of more than 1 item
     * @param {Boolean} [other=false] Offer the option "Other" that allows the user to enter their own value
     * Note: can not be used together with `multiple`
     * @param {Boolean} [noPurge=false] Allow invalid/unselectable choices. If not set, it'll remove/unset any
     * @param {Boolean} [noToggleAll=false] Hide the toggle-all option for multiselects
     *
     * @example
     * ```
     * <tx-select
     *     ng-model="country"
     *     tx-options="c.code as c.name group by c.continent for c in countries"
     *     btn-class="form-control"></tx-select>
     * ```
     */
    .component('txSelect', {
        bindings: {
            btnClass: '@',
            dropdownClass: '<',
            btnText: '=?',
            purge: '=?',
            btnIcon: '@',
            txOptions: '@',
            beforeSelect: '&?',
            beforeDeselect: '&?',
            confirmLargeGroups: '@?',
            sublabel: '@'
        },
        require: {
            'ngModel': 'ngModel'
        },
        templateUrl: templateUrl,
        controller: function($scope, $element, $attrs, txOptionParser, $q, $translate) {
            const $ctrl = this;

            let parser;
            let originalScope = $scope.$parent;

            $ctrl.$onInit = function() {
                parser = txOptionParser.parse($ctrl.txOptions);
                $ctrl.grouped = parser.groupBy !== null;
                $ctrl.multiple = _.has($attrs, 'multiple') && _.get($attrs, 'multiple', 'false') != 'false';
                $ctrl.showToggleAll = $ctrl.multiple && !_.has($attrs, 'noToggleAll');
                $ctrl.filter = _.has($attrs, 'filter');
                $ctrl.purge = !_.has($attrs, 'noPurge');
                $ctrl.selectOther = _.has($attrs, 'other');

                if ($ctrl.multiple && $ctrl.selectOther)
                    throw new Error('tx-select: Can\'t enable both multiple and other');

                _.defaults($ctrl, {
                    btnClass: 'btn btn-default',
                    btnIcon: 'fa fa-chevron-down'
                });

                $ctrl.ready = true;
                $ctrl.items = [];

                $scope.other = {
                    model: 'Other',
                    label: $translate.instant('models.metaData.other'),
                    value: '',
                    disabled: angular.noop,
                    selected: false
                };

                $attrs.$observe('disabled', v => $ctrl.disabled = v);
            };

            $ctrl.$postLink = function() {
                $element.addClass('tx-select');

                if (!$ctrl.beforeSelect)
                    $ctrl.beforeSelect = angular.noop;

                if (!$ctrl.beforeDeselect)
                    $ctrl.beforeDeselect = angular.noop;
            };

            /********************
             *   UI Helpers
             ********************/

            // Filter the items based on a search query
            $ctrl.search = _.debounce(function(search) {
                $ctrl.searching = search && search.length >= 3;

                updateItems(parser.source(originalScope), $ctrl.searching ? search.toLowerCase() : null);

                $scope.$applyAsync();
            }, 300);

            // Determine icon for an item
            $ctrl.itemIcon = function(item) {
                if ($ctrl.multiple)
                    return item.selected ? 'fa fa-check-square-o fa-fw' : 'fa fa-square-o fa-fw';

                return item.selected ? 'pull-right fa fa-check-square-o fa-fw' : 'hidden';
            };

            // Determine button text
            $ctrl.getBtnText = function() {
                if ($scope.other.selected)
                    return $scope.other.label;

                if (!$ctrl.ngModel.$modelValue)
                    return $attrs.placeholder || $ctrl.btnText || 'Select an option';

                if ($ctrl.btnText)
                    return $ctrl.btnText;

                if ($ctrl.multiple) {
                    return $ctrl.ngModel.$modelValue.length ?
                        $ctrl.ngModel.$modelValue.length + ' items selected' :
                        $attrs.placeholder || $ctrl.btnText || 'Select an option';
                }

                let items = $ctrl.items;

                if ($ctrl.grouped)
                    items = _.flatten(_.values(items));

                return _.get(_.find(items, {value: $ctrl.ngModel.$modelValue}), 'label', 'Select an option');
            };

            /********************
             *   UI Interaction callbacks
             ********************/

            // Focus filter if menu is opened and filter enabled
            $ctrl.onToggle = function(open) {
                if (open && $ctrl.filter)
                    $element.find('input')[0].focus();
            };

            // Toggle all items (if the first is selected, deselect all and vice-versa)
            $ctrl.toggleAll = function() {
                let items = $ctrl.items;

                if ($ctrl.grouped)
                    items = _.flatten(_.values(items));

                if ($ctrl.confirmLargeGroups &&
                    items.length > $ctrl.confirmLargeGroups &&
                    !confirm($translate.instant('common.notice.confirmToggle', {count: items.length})) // eslint-disable-line no-alert
                )
                    return;

                let direction = _.get(_.first(items), 'selected', false);

                _.forEach(items, item => {
                    if (item.selected === direction)
                        $ctrl.selectItem(item);
                });
            };

            // Select an item in the list
            $ctrl.selectItem = function(item) {
                if (item.disabled())
                    return;

                let callbackArgument = _.set({item: item}, parser.itemName, item.model);

                if ($ctrl.multiple) {
                    if (!_.isArray($ctrl.ngModel.$modelValue))
                        $ctrl.ngModel.$setViewValue([]);

                    if (item.selected) {
                        $q.resolve($ctrl.beforeDeselect(callbackArgument))
                            .then(() => {
                                let index = _.indexOf($ctrl.ngModel.$modelValue, item.value);

                                if (index >= 0)
                                    $ctrl.ngModel.$modelValue.splice(index, 1);
                            }, angular.noop);
                    } else {
                        $q.resolve($ctrl.beforeSelect(callbackArgument))
                            .then(() => {
                                let index = _.indexOf($ctrl.ngModel.$modelValue, item.value);
                                if (index < 0)
                                    $ctrl.ngModel.$modelValue.push(item.value);
                            }, angular.noop);
                    }
                } else {
                    if ($ctrl.ngModel.$modelValue === item.value)
                        return;

                    let currentlySelected = _.find($ctrl.items, {selected: true});
                    let currentCallbackArgument = _.set({item: currentlySelected}, parser.itemName, item.model);
                    let promise = null;

                    if (currentlySelected)
                        promise = $ctrl.beforeDeselect(currentCallbackArgument);

                    $q.resolve(promise)
                        .then(() => $ctrl.beforeSelect(callbackArgument))
                        .then(() => $ctrl.ngModel.$setViewValue(item.value), angular.noop);

                    $ctrl.isOpen = false;
                }

                $scope.$applyAsync();
            };

            $ctrl.selectItemOnEnter = function(event, item) {
                if (event.which === 13) {
                    $ctrl.selectItem(item);
                    $ctrl.isOpen = $ctrl.multiple;
                } else if (event.which === 27) {
                    $ctrl.isOpen = false;
                }
            };

            $ctrl.updateOtherValue = function() {
                $ctrl.ngModel.$setViewValue($scope.other.value);
            };

            // Select a group in the list
            $ctrl.selectGroup = function(items) {
                if (!$ctrl.multiple) return;

                let selecting = !_.get(items, '0.selected', false);

                if (!_.isArray($ctrl.ngModel.$modelValue))
                    $ctrl.ngModel.$setViewValue([]);

                if ($ctrl.confirmLargeGroups &&
                    items.length > $ctrl.confirmLargeGroups &&
                    !confirm($translate.instant('common.notice.confirmToggle', {count: items.length})) // eslint-disable-line no-alert
                )
                    return;

                _.reduce(items, (promise, item) => {
                    return promise.then(() => {
                        let index = _.indexOf($ctrl.ngModel.$modelValue, item.value);

                        if (selecting && index >= 0 || !selecting && index < 0)
                            return $q.resolve();

                        let callbackArgument = _.set({item: item}, parser.itemName, item.model);

                        if (!selecting) {
                            return $q.resolve($ctrl.beforeDeselect(callbackArgument))
                                .then(() => {
                                    $ctrl.ngModel.$modelValue.splice(index, 1);
                                }, angular.noop);
                        }

                        return $q.resolve($ctrl.beforeSelect(callbackArgument))
                            .then(() => {
                                $ctrl.ngModel.$setViewValue($ctrl.ngModel.$modelValue.concat([item.value]));
                            }, angular.noop);
                    });
                }, $q.resolve());

                $scope.$applyAsync();
            };

            $ctrl.selectGroupOnEnter = function(event, items) {
                if (event.which === 13) {
                    $ctrl.selectGroup(items);
                    $ctrl.isOpen = $ctrl.multiple;
                } else if (event.which === 27) {
                    $ctrl.isOpen = false;
                }
            };

            /*********************
             *    Data functions
             *********************/

            // Update local list of items if remote changes
            $scope.$watch(() => parser.source(originalScope), updateItems, true);

            // Update local list if model changes
            $scope.$watch('$ctrl.ngModel.$modelValue', checkSelected, true);

            /**
             * Sync internal with external state. Called when ngModel or source array for txOptions changes
             * @param {Any} model The reflected value of model
             */
            function checkSelected(model) {
                if (_.isNil(model)) return;

                // Create a flat list of selectable items
                let items = ($ctrl.grouped) ? _.flatten(_.values($ctrl.items)) : $ctrl.items;

                // Normalize selection to array
                let selected = _.compact(_.isArray(model) ? model : [model]);

                // Set internal state to reflect model
                _.forEach(items, item => {
                    item.selected = _.indexOf(selected, item.value) >= 0;
                });

                if ($ctrl.selectOther) {
                    // When txSelect is initialized with a value corresponding to "Other"
                    if (!_.some(items, 'selected') && !_.isNil(model))
                        $scope.other.value = model;

                    $scope.other.selected = model === $scope.other.value;
                }

                if (!$ctrl.multiple) {
                    // Update the outside ngModel value (unsetting model if item has disappeared from source array)
                    if ($ctrl.selectOther && $scope.other.selected)
                        $ctrl.ngModel.$setViewValue($scope.other.value);
                    else
                        $ctrl.ngModel.$setViewValue(!$ctrl.purge || _.find(items, {value: model}) ? model : null);
                } else {
                    // Update the outside ngModel value (removing selections that are no longer in source array)
                    let remainingSelected = _.filter(model, selected => {
                        return !$ctrl.purge || _.find(items, {value: selected}) !== undefined;
                    });

                    $ctrl.ngModel.$setViewValue(remainingSelected);
                }
            }

            /**
             * Update local list of items.
             *
             * Called when source array or search query changes
             * @param {Array<Any>} models List of source items
             * @param {String} [search] An optional search query
             */
            function updateItems(models, search) {
                $ctrl.items = [];

                if (!angular.isDefined(models) || models === null) return;

                _.forEach(models, model => {
                    let local = {};

                    local[parser.itemName] = model;

                    if (typeof search === 'string') {
                        let label = parser.viewMapper(local).toString().toLowerCase();
                        let groupBy = parser.groupBy ? (parser.groupBy(local) || '').toString().toLowerCase() : '';
                        let groupLabel = parser.groupLabel ? (parser.groupLabel(local) || '').toString().toLowerCase() : '';

                        if (label.indexOf(search) < 0 && groupBy.indexOf(search) < 0 && groupLabel.indexOf(search)) return;
                    }

                    $ctrl.items.push({
                        model: model,
                        selected: false,
                        label: parser.viewMapper(local),
                        value: parser.modelMapper(local),
                        groupBy: parser.groupBy ? parser.groupBy(local) : null,
                        groupLabel: parser.groupLabel ? parser.groupLabel(local) : null,
                        disabled: parser.disableWhen ? parser.disableWhen.bind(null, local) : angular.noop
                    });
                });

                if ($ctrl.items.length > 11)
                    $attrs.filter = true;

                $ctrl.filter = _.has($attrs, 'filter');

                if ($ctrl.grouped)
                    $ctrl.items = _.groupBy($ctrl.items, 'groupBy');

                if ($ctrl.ngModel)
                    checkSelected($ctrl.ngModel.$modelValue);
            }
        }
    }).name;
